import React, { useState, useEffect } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import {
  durationOfContractArray,
  probationPeriodArray,
  putGroupEdit,
  religionArray,
  statusArray,
} from "./candidateListFunctions";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

export default function GroupEditPopup({
  popupState,
  setPopupState,
  candidateData,
  setCandidateListData,
  checkedList,
  hideInputs = [],
  ResetFilter,
}) {
  const { projectId } = useParams();
  const dispatch = useDispatch();

  const [finalObj, setFinalObj] = useState({});
  const [disable, setDiasble] = useState(true);

  const [submitLoading, setSubmitLoading] = useState(false);

  const handleGroupEdit = async (e) => {
    e.preventDefault();
    const body = [];
    for (let selectedId of checkedList) {
      body.push({ ...finalObj, id: selectedId });
    }
    const response = await putGroupEdit(
      projectId,
      body,
      setCandidateListData,
      setSubmitLoading,
      dispatch
    );
    if (response.completed) {
      ResetFilter();
      setPopupState({ open: false });
    }
  };

  useEffect(() => {
    let isEmpty = Object.keys(finalObj).length == 0;
    if (!isEmpty) {
      setFinalObj((prevFinalObj) => {
        const newObj = { ...prevFinalObj };
        for (const key in newObj) {
          if (!newObj[key]) {
            delete newObj[key];
          } else {
            setDiasble(false);
          }
        }
        return newObj;
      });
    } else {
      setDiasble(true);
    }
  }, [finalObj]);

  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
        popupState.open ? "flex" : "hidden"
      }`}
    >
      <div className="max-w-xl w-full h-auto min-h-[15rem] max-h-[35rem] rounded-md bg-white/95 flex  flex-col p-4 relative overflow-y-scroll">
        <div className="flex justify-between items-center w-full">
          <div>
            <h1 className="text-xl font-semibold">Group Edit</h1>
            <h2 className="text-sm">Group Edit Candidate List</h2>
          </div>
          <h1
            className="text-md font-semibold cursor-pointer"
            onClick={() => {
              setPopupState((p) => ({ open: false }));
            }}
          >
            <IoMdClose />
          </h1>
        </div>
        <form className="px-5 py-2 mt-5" onSubmit={handleGroupEdit}>
          <ArraySelectInput
            title="Actual Profession"
            array={candidateData?.job_possition}
            objKey="job_position_id"
            setFinalObj={setFinalObj}
            hideInputs={hideInputs}
          />
          <ArraySelectInput
            title="Nationality"
            array={candidateData?.nationality}
            objKey="nationality_id"
            setFinalObj={setFinalObj}
            hideInputs={hideInputs}
          />
          <TextInput
            title="Selection Date"
            type="date"
            objKey="selection_date"
            setFinalObj={setFinalObj}
            hideInputs={hideInputs}
          />
          <ArraySelectInput
            title="Sector"
            array={candidateData?.sector}
            objKey="sector_id"
            setFinalObj={setFinalObj}
            hideInputs={hideInputs}
          />
          <ArraySelectInput
            title="Status"
            array={statusArray}
            objKey="status"
            setFinalObj={setFinalObj}
            hideInputs={hideInputs}
          />
          <ArraySelectInput
            title="Religion"
            array={religionArray}
            objKey="religion"
            setFinalObj={setFinalObj}
            hideInputs={hideInputs}
          />
          <TextInput
            type="number"
            title="Basic"
            objKey="basic"
            setFinalObj={setFinalObj}
            hideInputs={hideInputs}
          />
          <TextInput
            title="Food"
            objKey="food"
            setFinalObj={setFinalObj}
            hideInputs={hideInputs}
          />
          <TextInput
            type="number"
            title="Fixed OT"
            objKey="fixed_ot"
            setFinalObj={setFinalObj}
            hideInputs={hideInputs}
          />
          <TextInput
            type="number"
            title="HRA"
            objKey="hra"
            setFinalObj={setFinalObj}
            hideInputs={hideInputs}
          />
          <TextInput
            type="number"
            title="Travel Allowance"
            objKey="travel_allowance"
            setFinalObj={setFinalObj}
            hideInputs={hideInputs}
          />
          <TextInput
            type="number"
            title="Mobile Allowance"
            objKey="mobile_allowance"
            setFinalObj={setFinalObj}
            hideInputs={hideInputs}
          />
          <TextInput
            type="number"
            title="Air Ticket Allowance"
            objKey="air_ticket_allowance"
            setFinalObj={setFinalObj}
            hideInputs={hideInputs}
          />
          <TextInput
            type="number"
            title="Additional OT"
            objKey="additional_ot"
            setFinalObj={setFinalObj}
            hideInputs={hideInputs}
          />
          <TextInput
            type="number"
            title="Other Allowance"
            objKey="other_allowance"
            setFinalObj={setFinalObj}
            hideInputs={hideInputs}
          />
          <TextInput
            type="number"
            title="Duty Hours"
            objKey="duty_hours"
            setFinalObj={setFinalObj}
            hideInputs={hideInputs}
          />
          <TextInput
            type="number"
            title="Fixed OT Hours"
            objKey="fixed_ot_hours"
            setFinalObj={setFinalObj}
            hideInputs={hideInputs}
          />
          <ArraySelectInput
            title="Duration of Contract"
            array={durationOfContractArray}
            objKey="duration_of_contract"
            setFinalObj={setFinalObj}
            hideInputs={hideInputs}
          />
          <ArraySelectInput
            title="Probation Period"
            array={probationPeriodArray}
            objKey="probation_period"
            setFinalObj={setFinalObj}
            hideInputs={hideInputs}
          />
          <div className="p-2  w-full flex gap-3">
            <button
              type="button"
              className="ring-1 ring-slate-300  uppercase w-full text-xs rounded-md py-2 flex justify-center items-center gap-2"
              disabled={submitLoading}
              onClick={() => setPopupState({ open: false })}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={
                disable
                  ? "bg-red opacity-50 uppercase w-full text-xs text-white rounded-md py-2 flex justify-center items-center gap-2"
                  : "bg-red uppercase w-full text-xs text-white rounded-md py-2 flex justify-center items-center gap-2"
              }
              disabled={submitLoading || disable}
            >
              Submit
              {submitLoading && <CgSpinner className="animate-spin" />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const ArraySelectInput = ({
  title,
  array,
  objKey,
  setFinalObj,
  hideInputs = [],
}) => {
  return (
    <div
      className={`form-control w-full gap-[0.15rem] mb-4 ${
        hideInputs.includes(objKey) ? "hidden" : ""
      }`}
    >
      <label className="label py-0">
        <span className="label-text">{title}</span>
      </label>
      <select
        className="select select-sm select-bordered"
        onChange={(e) =>
          setFinalObj((prevState) => ({
            ...prevState,
            [objKey]: e.target.value,
          }))
        }
      >
        <option value="" hidden>
          Select an Option
        </option>
        {array?.map((data) => (
          <option value={data?.id || data} key={data?.id}>
            {data?.name || data}
          </option>
        ))}
      </select>
    </div>
  );
};

const TextInput = ({ title, type, objKey, setFinalObj, hideInputs }) => {
  return (
    <div
      className={`form-control w-full gap-[0.15rem] mb-4 ${
        hideInputs.includes(objKey) ? "hidden" : ""
      }`}
    >
      <label className="label py-0">
        <span className="label-text">{title}</span>
      </label>
      <input
        type={type || "text"}
        placeholder="Type here"
        className="input input-sm input-bordered w-full"
        onChange={(e) =>
          setFinalObj((prevState) => ({
            ...prevState,
            [objKey]:
              type == "date"
                ? String(e.target.value).split("-").reverse().join("-")
                : e.target.value,
          }))
        }
      />
    </div>
  );
};
